import * as React from 'react'
import styled from 'styled-components'
import { Content as Content_ } from '../atoms/Content/index'
import { Layout } from '../atoms/Layout'
import { Nav } from '../atoms/Nav'
import { LoginFormContainer } from '../organisms/LoginForm/LoginFormContainer'
import { media } from '../utils/media'

const language = process.env.REACT_APP_LANGUAGE


export const LoginPage = () => (
  <Layout hasStaticBackground>
    <Nav.Bar>
      <Nav.HomeButtonWeb />
    </Nav.Bar>
    <Content>
      <RowTablet>
        <H1>{language === 'es' ? 'L-Web' : 'Web'}</H1>
        <DividerTablet />
        <ColRight>
          {language === 'es' ? (
            <H2>Inicio de Sesión</H2>
          ) : (<H2>Login</H2>)}
          <LoginFormContainer />
        </ColRight>
      </RowTablet>
    </Content>
  </Layout>
)

const Content = styled(Content_)`
  text-align: center;
  ${media.tablet`
    text-align: left;
  `}
`

const RowTablet = styled.div`
  ${media.tablet`
    margin-top: 95px;
    display: flex;
  `}
`

const ColRight = styled.div`
  flex: 1 0 auto;
  margin-bottom: 30px;
`

const DividerTablet = styled.div`
  ${media.tablet`
    width: 1px;
    background: #BEB8D4;
    margin: 0 60px;
  `}
`

const H1 = styled.h1`
  margin-top: 20px;
  font-family: Pacifico;
  font-size: 75px;
  color: #172129;

  ${media.tablet`
    margin: 30px 70px 0 50px;
    font-size: 103px;
  `}
`

const H2 = styled.h2`
  margin-top: 15px;
  font-family: Nunito;
  font-size: 38px;
  font-weight: 900;
  color: #12385b;

  ${media.tablet`
    margin-top: 30px;
    font-size: 54px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/LoginPage.tsx